module.exports = __webpack_public_path__ + "img/slide6-992.5a58eb8c.png";